import { schema } from "normalizr";
import { WidgetSchema } from "./widget";

const DashboardWidgetSchema = new schema.Entity("dashboardWidgets", {
  widget: WidgetSchema
});

const DashboardWidgetArraySchema = new schema.Array(DashboardWidgetSchema);

export { DashboardWidgetSchema, DashboardWidgetArraySchema };